import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'

const DiamondEducation = () => {
    return (
        <>
            <div className='dfld_diamond_Education_Section'>
                <Container className='dfl_custome_container_staticpage'>
                    <Row className='w-100 m-auto'>
                        <Col sm={12} md={6} lg={6} className="pd-less">
                            <div className="d-secv1">
                                <h2 className="both-box-hd text-uppercase"> Certified <span className="conf-spn">DIAMONDS </span> </h2>
                                <p className="both-pr">Transparency is key at Diamonds For Less. All of our loose diamonds are certified conflict-free and graded by one of the top 3 labs: GIA, AGS, or IGI. You can view the diamond certificates for each diamond on our website, allowing you to make an informed decision. </p>
                                <NavLink to="/diamonds"> Shop Now</NavLink>
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={6} className="pd-less">
                            <div className="d-secv2">
                                <h2 className="both-box-hd text-uppercase">  <span className="conf-spn">Diamond</span> Education </h2>
                                <p className="both-pr"> Each diamond is individually selected and graded against its color, clarity, cut and carat weight, but the Diamonds For Less process goes beyond standard diamond grading. Choose the perfect diamond with confidence by learning how to select the ideal diamond for your jewellery. </p>
                                <NavLink to="/education-diamonds">Learn More</NavLink>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default DiamondEducation